import router from '../router'

export default {
  namespaced: true,

  state: {
    authUser: null,
    unauthorized: false
  },

  getters: {
    selectAuthUser: (state) => state.authUser,
    selectUnauthorized: (state) => state.unauthorized
  },

  mutations: {
    SET_AUTH_USER(state, authUser) {
      state.authUser = authUser
    },
    SET_UNAUTHORIZED(state, unauthorized) {
      state.unauthorized = unauthorized
    }
  },

  actions: {
    setUnauthorized({ commit }, unauthorized) {
      commit('SET_UNAUTHORIZED', unauthorized)
    },
    async createAuthEventBus({ commit, dispatch }, initializeApp) {
      // Remove Amplify Hub.listen - replace with your own auth system
      await dispatch('setCurrentUser')
      await initializeApp()
    },
    async setCurrentUser({ commit, dispatch, getters }) {
      try {
        // Replace with your own authentication logic
        // For now, we'll just clear any existing auth
        if (getters.selectAuthUser) {
          await dispatch('resetAuth')
        }
      } catch (e) {
        if (getters.selectAuthUser) {
          await dispatch('resetAuth')
        }
      }
    },
    async resetAuth({ commit, getters }) {
      // Replace with your own sign out logic
      commit('SET_AUTH_USER', null)
    }
  }
}
